import { __extends } from "tslib";
var NoEditorSDKProvidedForEditorSDKMode = /** @class */ (function (_super) {
    __extends(NoEditorSDKProvidedForEditorSDKMode, _super);
    function NoEditorSDKProvidedForEditorSDKMode() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nNo `editorSDK` was passed to TPASettingsProvider.\nIn order to work with tpa-settings in editorSDK mode, you have to pass the Editor SDK to the Settings panel.\n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NoEditorSDKProvidedForEditorSDKMode;
}(Error));
export { NoEditorSDKProvidedForEditorSDKMode };
//# sourceMappingURL=NoEditorSDKProvidedForEditorSDKMode.js.map